import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/public/Header';
import Footer from '../../components/public/Footer';
import { fetchPublishedRoster } from '../../services/publishingRoster';

// /auth/login is routed by the load balancer's URL map to the separate
// Next.js portal Cloud Run service, not to this React app — plain <a>,
// not a react-router <Link>, since it's a full cross-app navigation.
const CLIENT_PORTAL_URL = '/auth/login';

/* ─── Arrow icon (template button_icon) ─────────────────────────── */
const ArrowSvg = () => (
  <>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 11 9" fill="none" className="icon-1x1-sm-minus">
      <path d="M5.76953 8.91406L5.00391 8.14844L6.44629 6.71289C6.7334 6.42578 7.03418 6.13411 7.34863 5.83789C7.66309 5.53711 7.9707 5.24772 8.27148 4.96973C8.06185 4.97884 7.85221 4.98796 7.64258 4.99707C7.43294 5.00163 7.22331 5.00391 7.01367 5.00391H0V3.91016H7.01367C7.22331 3.91016 7.43294 3.91471 7.64258 3.92383C7.85221 3.92839 8.06185 3.93522 8.27148 3.94434C7.9707 3.66634 7.66309 3.37923 7.34863 3.08301C7.03418 2.78223 6.7334 2.48828 6.44629 2.20117L5.00391 0.765625L5.76953 0L10.2266 4.45703L5.76953 8.91406Z" fill="currentColor" />
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 11 9" fill="none" className="icon-1x1-sm-minus">
      <path d="M5.76953 8.91406L5.00391 8.14844L6.44629 6.71289C6.7334 6.42578 7.03418 6.13411 7.34863 5.83789C7.66309 5.53711 7.9707 5.24772 8.27148 4.96973C8.06185 4.97884 7.85221 4.98796 7.64258 4.99707C7.43294 5.00163 7.22331 5.00391 7.01367 5.00391H0V3.91016H7.01367C7.22331 3.91016 7.43294 3.91471 7.64258 3.92383C7.85221 3.92839 8.06185 3.93522 8.27148 3.94434C7.9707 3.66634 7.66309 3.37923 7.34863 3.08301C7.03418 2.78223 6.7334 2.48828 6.44629 2.20117L5.00391 0.765625L5.76953 0L10.2266 4.45703L5.76953 8.91406Z" fill="currentColor" />
    </svg>
  </>
);

/* ─── Corner decorators (template project card corners) ─────────── */
const CornerDecors = () => (
  <div className="corners_wrap">
    <div className="corner_block is-top-left"><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 41 41" fill="none"><path d="M40.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V40.5" stroke="currentColor"/></svg></div>
    <div className="corner_block is-top-right"><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 41 41" fill="none"><path d="M0 0.5H38C39.1046 0.5 40 1.39543 40 2.5V40.5" stroke="currentColor"/></svg></div>
    <div className="corner_block is-bottom-left"><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 41 41" fill="none"><path d="M40.5 40H2.5C1.39543 40 0.5 39.1046 0.5 38V0" stroke="currentColor"/></svg></div>
    <div className="corner_block is-bottom-right"><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 41 41" fill="none"><path d="M0 40H38C39.1046 40 40 39.1046 40 38V0" stroke="currentColor"/></svg></div>
  </div>
);

/* ─── Marquee image list ─────────────────────────────────────────── */
const MARQUEE_IMGS = [
  { src: '/woss-publishing-template/images/Project-Thumbnail-1.avif',        srcSet: '/woss-publishing-template/images/7c79fb778af67050054ac3d9c1749c93_Project-Thumb-1-p-500.avif 500w, /woss-publishing-template/images/7c79fb778af67050054ac3d9c1749c93_Project-Thumb-1-p-800.avif 800w, /woss-publishing-template/images/7c79fb778af67050054ac3d9c1749c93_Project-Thumb-1-p-1080.avif 1080w, /woss-publishing-template/images/Project-Thumbnail-1.avif 1336w', alt: 'Woss Publishing artist' },
  { src: '/woss-publishing-template/images/Project-Thumbnail-2.avif',        srcSet: '/woss-publishing-template/images/c58b5d0256809dd7386193b019835958_Project-Thumb-2-p-500.avif 500w, /woss-publishing-template/images/c58b5d0256809dd7386193b019835958_Project-Thumb-2-p-800.avif 800w, /woss-publishing-template/images/c58b5d0256809dd7386193b019835958_Project-Thumb-2-p-1080.avif 1080w, /woss-publishing-template/images/Project-Thumbnail-2.avif 1336w', alt: 'Woss Publishing artist' },
  { src: '/woss-publishing-template/images/Project-Thumb-3_1Project-Thumb-3.avif', srcSet: '/woss-publishing-template/images/Project-Thumb-3_1-p-500.avif 500w, /woss-publishing-template/images/Project-Thumb-3_1-p-800.avif 800w, /woss-publishing-template/images/Project-Thumb-3_1-p-1080.avif 1080w, /woss-publishing-template/images/Project-Thumb-3_1Project-Thumb-3.avif 1336w', alt: 'Woss Publishing artist' },
  { src: '/woss-publishing-template/images/Project-Thumbnail-4.avif',        srcSet: '/woss-publishing-template/images/582534f114257c43b260ade59e532e0f_Project-Thumb-4-p-500.avif 500w, /woss-publishing-template/images/582534f114257c43b260ade59e532e0f_Project-Thumb-4-p-800.avif 800w, /woss-publishing-template/images/582534f114257c43b260ade59e532e0f_Project-Thumb-4-p-1080.avif 1080w, /woss-publishing-template/images/Project-Thumbnail-4.avif 1336w', alt: 'Woss Publishing artist' },
  { src: '/woss-publishing-template/images/Project-Thumbnail-5.avif',        srcSet: '/woss-publishing-template/images/80403eb14468751527543aed94cb019b_Project-Thumb-5-p-500.avif 500w, /woss-publishing-template/images/80403eb14468751527543aed94cb019b_Project-Thumb-5-p-800.avif 800w, /woss-publishing-template/images/80403eb14468751527543aed94cb019b_Project-Thumb-5-p-1080.avif 1080w, /woss-publishing-template/images/Project-Thumbnail-5.avif 1336w', alt: 'Woss Publishing artist' },
];

/* ─── Publishing services (services section) ─────────────────────── */
const SERVICES = [
  {
    title: 'Publishing Administration',
    items: ['Composition registration with PROs', 'Licensing and catalog oversight'],
    img:   '/woss-publishing-template/images/Project-Thumbnail-2.avif',
    imgSrcSet: '/woss-publishing-template/images/c58b5d0256809dd7386193b019835958_Project-Thumb-2-p-500.avif 500w, /woss-publishing-template/images/Project-Thumbnail-2.avif 1336w',
  },
  {
    title: 'Rights & Royalties',
    items: ['Ownership documentation and splits', 'Royalty reporting through the portal'],
    img:   '/woss-publishing-template/images/Project-Thumbnail-4.avif',
    imgSrcSet: '/woss-publishing-template/images/582534f114257c43b260ade59e532e0f_Project-Thumb-4-p-500.avif 500w, /woss-publishing-template/images/Project-Thumbnail-4.avif 1336w',
  },
  {
    title: 'Creative Opportunities',
    items: ['Synch consideration support', 'Catalog development and analytics'],
    img:   '/woss-publishing-template/images/Project-Thumbnail-1.avif',
    imgSrcSet: '/woss-publishing-template/images/7c79fb778af67050054ac3d9c1749c93_Project-Thumb-1-p-500.avif 500w, /woss-publishing-template/images/Project-Thumbnail-1.avif 1336w',
  },
];

/* ─── FAQ content ────────────────────────────────────────────────── */
const FAQS = [
  {
    q: 'Who can join Woss Publishing?',
    a: 'Woss Publishing works with songwriters, producers, recording artists, and catalog owners. Access requires an invitation from a Publishing administrator.',
  },
  {
    q: 'What does publishing administration include?',
    a: 'We handle composition registration, rights documentation, ownership and split management, royalty reporting, and catalog analytics through a secure portal.',
  },
  {
    q: 'How does the Warner Chappell Music partnership work?',
    a: 'Warner Chappell Music is our main publishing partner. Through this relationship, we support professional publishing administration, rights management, and royalty services. Woss Publishing does not imply ownership or guaranteed commercial results from this partnership.',
  },
  {
    q: 'How do I access the portal?',
    a: 'Portal access is invitation-only. Once invited, you will receive a secure link to complete your registration. Existing Woss Music accounts can be linked to your Publishing profile.',
  },
];

/* ─── Contact form ───────────────────────────────────────────────── */
const EMPTY_FORM = {
  fullName: '', email: '', phone: '', companyRole: '',
  inquiryType: '', message: '', consent: false, honeypot: '',
};
const INQUIRY_TYPES = [
  'Songwriter or producer',
  'Artist or management',
  'Catalog administration',
  'Publishing partnership',
  'Synch inquiry',
  'Portal support',
  'General inquiry',
];

/* ─── FAQ item ───────────────────────────────────────────────────── */
function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq${open ? ' is-open' : ''}`}>
      <button
        className="faq_heading"
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
        style={{ background: 'none', border: 'none', width: '100%', cursor: 'pointer', textAlign: 'left', padding: 0 }}
      >
        <h3 className="text-size-md letter-spacing-normal text-weight-medium">{q}</h3>
        <div className="faq_icon">
          <div className="faq_icon-line is-1" />
          {!open && <div className="faq_icon-line is-2" />}
        </div>
      </button>
      {open && (
        <div className="faq_answer">
          <div className="faq_content">
            <p className="text-size-md text-color-secondary">{a}</p>
          </div>
        </div>
      )}
    </div>
  );
}

/* ─── Roster card ────────────────────────────────────────────────── */
function RosterCard({ profile }) {
  const [imgErr, setImgErr] = useState(false);
  const fallback = '/woss-publishing-template/images/Portrait-Image.avif';

  return (
    <div className="slider_item-showcase">
      <div className="project_showcase-card">
        <Link to={`/roster/${profile.slug}`} className="project_item-link w-inline-block" aria-label={`View profile: ${profile.display_name}`}>
          <div className="project_item-visual">
            <img
              src={imgErr || !profile.profile_image_url ? fallback : profile.profile_image_url}
              loading="lazy"
              alt={profile.display_name}
              className="full-image"
              onError={() => setImgErr(true)}
            />
          </div>
          <CornerDecors />
          <div className="project_item-button">
            <div className="button">
              <span className="text-size-sm">{profile.display_name}</span>
              <div className="button_icon"><ArrowSvg /></div>
            </div>
          </div>
        </Link>
      </div>
      {profile.professional_category && (
        <p className="text-size-sm text-color-secondary" style={{ marginTop: '0.5rem' }}>
          {profile.professional_category}
        </p>
      )}
    </div>
  );
}

/* ─── Component ──────────────────────────────────────────────────── */
export default function HomePage() {
  const formStartTs = useRef(Date.now());

  /* Roster state */
  const [roster, setRoster]         = useState([]);
  const [rosterStatus, setRosterStatus] = useState('loading'); // loading | ready | error

  /* Contact form state */
  const [form, setForm]             = useState(EMPTY_FORM);
  const [formStatus, setFormStatus] = useState('idle'); // idle | sending | success | error
  const [formError, setFormError]   = useState('');

  /* Load roster from API */
  useEffect(() => {
    fetchPublishedRoster()
      .then(data => { setRoster(Array.isArray(data) ? data : (data.profiles || [])); setRosterStatus('ready'); })
      .catch(() => setRosterStatus('error'));
  }, []);

  /* Load scripts after React renders */
  useEffect(() => {
    const load = (src, integrity, onload) => {
      if (document.querySelector(`script[src="${src}"]`)) { if (onload) onload(); return; }
      const s = document.createElement('script');
      s.src = src; s.type = 'text/javascript';
      if (integrity) { s.integrity = integrity; s.crossOrigin = 'anonymous'; }
      s.onload = onload;
      document.body.appendChild(s);
    };
    load(
      'https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js',
      'sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0=',
      () => load('/woss-publishing-template/js/webflow.js', null, () => {
        load('https://cdn.prod.website-files.com/gsap/3.15.0/gsap.min.js', null, () => {
          load('https://cdn.prod.website-files.com/gsap/3.15.0/SplitText.min.js', null, null);
          load('https://cdn.prod.website-files.com/gsap/3.15.0/ScrollTrigger.min.js', null, null);
        });
      })
    );
  }, []);

  /* Form handlers */
  const handleField = useCallback((e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  }, []);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setFormError('');
    if (form.honeypot) return;
    if (!form.fullName.trim() || !form.email.trim() || !form.inquiryType || !form.message.trim()) {
      setFormError('Please complete all required fields.');
      return;
    }
    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRe.test(form.email.trim())) { setFormError('Please enter a valid email address.'); return; }
    if (!form.consent) { setFormError('Please confirm your consent before submitting.'); return; }

    setFormStatus('sending');
    try {
      const res = await fetch('/api/contact/publishing', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          fullName: form.fullName.trim(), email: form.email.trim().toLowerCase(),
          phone: form.phone.trim(), companyRole: form.companyRole.trim(),
          inquiryType: form.inquiryType, message: form.message.trim(),
          consent: form.consent, source: 'wosspublishing.com',
          _formStart: formStartTs.current,
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.success) {
        setFormStatus('error');
        setFormError(data.message || 'We could not send your inquiry. Please try again or email global@wosspublishing.com.');
        return;
      }
      setFormStatus('success');
      setForm(EMPTY_FORM);
    } catch {
      setFormStatus('error');
      setFormError('We could not send your inquiry. Please try again or email global@wosspublishing.com.');
    }
  }, [form]);

  return (
    <div className="page-wrapper">
      <Header />

      <main className="main-wrapper">

        {/* ── HERO ──────────────────────────────────────────────────── */}
        <header id="home" className="section_home-hero">
          <div className="padding-global">
            <div className="container-large">
              <div className="home-hero_title">
                <h1 className="heading-style-h1">
                  Register your songs.<br />Protect your rights.<br /><span className="text-shadow">Collect what you're owed.</span>
                </h1>
                <h2 className="heading-style-d3">Woss Publishing</h2>
              </div>
            </div>
          </div>
          {/* Scrolling marquee */}
          <div className="home-hero_projects">
            <div className="projects_marquee">
              {[0, 1, 2].map(i => (
                <div key={i} className="projects_marquee-list">
                  {MARQUEE_IMGS.map((img, j) => (
                    <a key={j} aria-label="Woss Publishing roster" href="/#roster" className="projects_marquee-item w-inline-block">
                      <img src={img.src} loading="lazy" alt={img.alt} srcSet={img.srcSet} sizes="(max-width:1336px) 100vw, 1336px" className="project_marquee-img" />
                    </a>
                  ))}
                </div>
              ))}
            </div>
          </div>
          <div className="padding-global">
            <div className="container-large">
              <div className="home-hero_bottom">
                <div className="home-hero_subcontent">
                  <p data-load-text="" className="text-size-md">
                    Woss Publishing administers your compositions — registration, splits,
                    royalty collection, and catalog reporting — through a secure portal
                    built for the people who make the music. Main publishing partner: Warner Chappell Music.
                  </p>
                </div>
                <div className="home-hero_social">
                  <a href={CLIENT_PORTAL_URL} className="button w-inline-block">
                    <span className="text-size-sm">Portal</span>
                    <div className="button_icon"><ArrowSvg /></div>
                  </a>
                  <a href="/#who-we-are" className="social_link">Discover</a>
                  <a href="/#roster" className="social_link">Roster</a>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* ── WHO WE ARE ────────────────────────────────────────────── */}
        <section id="who-we-are" className="section_home-about">
          <div className="theme-color-light">
            <div className="background-color-primary">
              <div className="padding-global padding-section-large">
                <div className="container-large">
                  <div className="home-about_component">
                    <div className="home-about_heading">
                      <div className="max-width-large">
                        <h2 className="heading-style-h2">We make sure every play, sync, and stream gets back to you.</h2>
                      </div>
                      <div className="max-width-xsmall">
                        <p data-load-text="">Administration handled. Royalties tracked. Catalog protected.</p>
                      </div>
                    </div>
                    <div className="home-about_capabilities">
                      <div className="home-about_visual">
                        <img
                          src="/woss-publishing-template/images/Portrait-Image.avif"
                          loading="lazy"
                          width="400"
                          height="300"
                          alt="Woss Publishing — built for the song"
                          className="full-image"
                        />
                      </div>
                      <div className="about_capabilities-list">
                        <p data-load-text="">Composition registration with PROs worldwide</p>
                        <p data-load-text="">Split sheets, ownership docs, and royalty statements in one portal</p>
                        <p data-load-text="">Main publishing partner: Warner Chappell Music</p>
                      </div>
                      <div className="about_experience">
                        <div className="experience_number">
                          <span data-load-text="" className="heading-style-h4">10+</span>
                          <div className="experience_subheading">
                            <div data-load-text="" className="text-size-md">Roster artists</div>
                          </div>
                        </div>
                        <div className="experience_number">
                          <span data-load-text="" className="heading-style-h4">Global</span>
                          <div className="experience_subheading">
                            <div data-load-text="" className="text-size-md">Music ecosystem</div>
                          </div>
                        </div>
                        <div className="experience_number">
                          <span data-load-text="" className="heading-style-h4">Secure</span>
                          <div className="experience_subheading">
                            <div data-load-text="" className="text-size-md">Reporting portal</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div data-wf--rectangle-background--position="bottom-left" className="rectangle_wrap w-variant-fbd23381-a6b0-ab98-5dea-da2f3dacf7df">
            <div data-wf--rectangle-shape--variant="light" className="rectangle_shape w-variant-5bf2dcb1-e8c1-b1f1-033d-4af6b1cf8283" />
          </div>
        </section>

        {/* ── ROSTER ────────────────────────────────────────────────── */}
        <section id="roster" className="section_home-project">
          <div data-wf--rectangle-background--position="top-right" className="rectangle_wrap w-variant-feaec6ca-a736-41d4-4cc1-f025bf7860d5">
            <div data-wf--rectangle-shape--variant="base" className="rectangle_shape" />
          </div>
          <div className="padding-global padding-section-large">
            <div className="container-large">
              <div className="home-project_component">
                <div className="home-project_heading">
                  <div className="max-width-medium">
                    <h2 className="heading-style-h2">The writers and producers behind the music.</h2>
                  </div>
                  <div className="max-width-small">
                    <p data-load-text="" className="text-size-md">
                      From solo songwriters to production teams — Woss Publishing
                      represents a curated group of creators whose catalogs we
                      administer and protect.
                    </p>
                  </div>
                </div>
                {/* Roster grid */}
                <section className="section_projects-showcase" style={{ paddingTop: '2rem' }}>
                  <div className="projects-showcase_component">
                    <h2 data-load-text="" className="text-size-sm letter-spacing-normal">Roster</h2>
                    <div className="projects-showcase_grid">
                      {rosterStatus === 'loading' && (
                        <div className="wp-roster-loading">Loading roster…</div>
                      )}
                      {rosterStatus === 'error' && (
                        <div className="wp-roster-error">Roster unavailable. Please try again later.</div>
                      )}
                      {rosterStatus === 'ready' && roster.length === 0 && (
                        <div className="wp-roster-empty">Roster profiles coming soon.</div>
                      )}
                      {rosterStatus === 'ready' && roster.map(profile => (
                        <RosterCard key={profile.slug || profile.id} profile={profile} />
                      ))}
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
          <div data-wf--rectangle-background--position="bottom-left" className="rectangle_wrap w-variant-fbd23381-a6b0-ab98-5dea-da2f3dacf7df">
            <div data-wf--rectangle-shape--variant="base" className="rectangle_shape" />
          </div>
        </section>

        {/* ── PUBLISHING SERVICES ───────────────────────────────────── */}
        <section id="services" className="section_home-services">
          <div data-wf--rectangle-background--position="top-right" className="rectangle_wrap w-variant-feaec6ca-a736-41d4-4cc1-f025bf7860d5">
            <div data-wf--rectangle-shape--variant="light" className="rectangle_shape w-variant-5bf2dcb1-e8c1-b1f1-033d-4af6b1cf8283" />
          </div>
          <div className="theme-color-light">
            <div className="background-color-primary">
              <div className="padding-global padding-section-large">
                <div className="container-large">
                  <div className="home-services_component">
                    <div className="basic_heading is-services">
                      <h2 className="heading-style-h2">Administration, rights, and royalties — handled.</h2>
                    </div>
                    <div className="home-services_wrap">
                      <div className="home-services_list">
                        {SERVICES.map(svc => (
                          <div key={svc.title} className="service_item-wrap">
                            <div className="service_item">
                              <div className="service_item-title">
                                <h3 className="heading-style-h3">{svc.title}</h3>
                              </div>
                              <div className="service_item-description">
                                <ul className="service_item-list">
                                  {svc.items.map(it => (
                                    <li key={it} className="text-size-md">{it}</li>
                                  ))}
                                </ul>
                              </div>
                              <div className="service_visual">
                                <img
                                  src={svc.img}
                                  loading="lazy"
                                  width="233"
                                  height="175"
                                  alt={svc.title}
                                  srcSet={svc.imgSrcSet}
                                  sizes="233px"
                                  className="service_image"
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div data-wf--rectangle-background--position="bottom-left" className="rectangle_wrap w-variant-fbd23381-a6b0-ab98-5dea-da2f3dacf7df">
            <div data-wf--rectangle-shape--variant="light" className="rectangle_shape w-variant-5bf2dcb1-e8c1-b1f1-033d-4af6b1cf8283" />
          </div>
        </section>

        {/* ── SYNCH ─────────────────────────────────────────────────── */}
        <section id="synch" className="section_home-reviews">
          <div data-wf--rectangle-background--position="top-right" className="rectangle_wrap w-variant-feaec6ca-a736-41d4-4cc1-f025bf7860d5">
            <div data-wf--rectangle-shape--variant="base" className="rectangle_shape" />
          </div>
          <div className="padding-global padding-section-large">
            <div className="container-large">
              <div className="home-reviews_component">
                <div className="basic_heading">
                  <h2 className="heading-style-h2">Get your music into film, TV, ads, and games.</h2>
                </div>
                <span data-load-text="" className="text-size-md">Synch</span>
                <div style={{ maxWidth: '42rem', marginTop: '2rem' }}>
                  <p className="text-size-md text-color-secondary">
                    Woss Publishing supports the presentation and consideration of suitable
                    works for synchronization opportunities across film, television, advertising,
                    games, and digital media. We work with music supervisors, agencies, and
                    content creators looking to license music from our catalog.
                  </p>
                  <p className="text-size-md text-color-secondary" style={{ marginTop: '1rem' }}>
                    To submit a sync brief or licensing inquiry, use the contact form below
                    or email <a href="mailto:global@wosspublishing.com" style={{ color: 'inherit' }}>global@wosspublishing.com</a>.
                    Include your project type, creative direction, territory, and any licensing
                    parameters. No guaranteed placements or commercial results.
                  </p>
                  <div style={{ marginTop: '2rem' }}>
                    <a href="/#contact" className="button w-inline-block">
                      <span className="text-size-sm">Submit a Brief</span>
                      <div className="button_icon"><ArrowSvg /></div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── FAQ / COMMON QUESTIONS ────────────────────────────────── */}
        <section className="section_home-faqs">
          <div className="padding-global padding-section-large">
            <div className="container-large">
              <div className="home-faqs_component">
                <div className="basic_heading">
                  <h2 className="heading-style-h2">Common questions</h2>
                </div>
                <span data-load-text="" className="text-size-md">FAQ</span>
                <div className="faqs_wrap">
                  {FAQS.map(faq => (
                    <FaqItem key={faq.q} q={faq.q} a={faq.a} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── PORTAL CTA ────────────────────────────────────────────── */}
        <section className="cta">
          <div data-wf--rectangle-background--position="top-left" className="rectangle_wrap">
            <div data-wf--rectangle-shape--variant="light" className="rectangle_shape w-variant-5bf2dcb1-e8c1-b1f1-033d-4af6b1cf8283" />
          </div>
          <div className="theme-color-light">
            <div className="background-color-primary">
              <div className="padding-global padding-section-large">
                <div className="container-large">
                  <div className="cta_component">
                    <div className="cta_title">
                      <h2 className="heading-style-h2">Your statements and catalog are waiting.</h2>
                    </div>
                    <div className="cta_content">
                      <p data-load-text="" className="text-color-secondary">
                        Log in to view your song registrations, royalty statements,
                        ownership documents, and account details — all in one place.
                      </p>
                      <div className="overflow-hidden">
                        <div>
                          <a href={CLIENT_PORTAL_URL} className="button w-inline-block">
                            <span className="text-size-sm">Access Portal</span>
                            <div className="button_icon"><ArrowSvg /></div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div data-wf--rectangle-background--position="bottom-right" className="rectangle_wrap w-variant-7c3e154f-11b3-7653-d062-3f526a4f801e">
            <div data-wf--rectangle-shape--variant="light" className="rectangle_shape w-variant-5bf2dcb1-e8c1-b1f1-033d-4af6b1cf8283" />
          </div>
        </section>

        {/* ── CONTACT ───────────────────────────────────────────────── */}
        <section id="contact" className="section_home-faqs">
          <div className="padding-global padding-section-large">
            <div className="container-large">
              <div className="home-faqs_component">
                <div className="basic_heading">
                  <h2 className="heading-style-h2">Contact Woss Publishing</h2>
                </div>
                <span data-load-text="" className="text-size-md">
                  <a href="mailto:global@wosspublishing.com" style={{ color: 'inherit' }}>
                    global@wosspublishing.com
                  </a>
                </span>

                <div className="faqs_wrap" style={{ marginTop: '2rem', maxWidth: '36rem' }}>
                  {formStatus === 'success' ? (
                    <div className="form_message-success is-visible" role="status">
                      Thank you. Your inquiry has been received by Woss Publishing.
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit} noValidate aria-label="Contact Woss Publishing">
                      {/* Honeypot */}
                      <input type="text" name="honeypot" value={form.honeypot} onChange={handleField}
                        tabIndex={-1} aria-hidden="true" style={{ display: 'none' }} autoComplete="off" />

                      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                        <div>
                          <label htmlFor="wp-fullName" className="text-size-sm text-color-secondary">Full name *</label>
                          <input id="wp-fullName" className="w-input" name="fullName" type="text" maxLength={100}
                            value={form.fullName} onChange={handleField} required aria-required="true"
                            style={{ display: 'block', width: '100%', marginTop: '0.4rem' }} />
                        </div>
                        <div>
                          <label htmlFor="wp-email" className="text-size-sm text-color-secondary">Email address *</label>
                          <input id="wp-email" className="w-input" name="email" type="email" maxLength={200}
                            value={form.email} onChange={handleField} required aria-required="true" autoComplete="email"
                            style={{ display: 'block', width: '100%', marginTop: '0.4rem' }} />
                        </div>
                        <div>
                          <label htmlFor="wp-phone" className="text-size-sm text-color-secondary">Phone (optional)</label>
                          <input id="wp-phone" className="w-input" name="phone" type="tel" maxLength={30}
                            value={form.phone} onChange={handleField} autoComplete="tel"
                            style={{ display: 'block', width: '100%', marginTop: '0.4rem' }} />
                        </div>
                        <div>
                          <label htmlFor="wp-companyRole" className="text-size-sm text-color-secondary">Company or role (optional)</label>
                          <input id="wp-companyRole" className="w-input" name="companyRole" type="text" maxLength={100}
                            value={form.companyRole} onChange={handleField}
                            style={{ display: 'block', width: '100%', marginTop: '0.4rem' }} />
                        </div>
                        <div>
                          <label htmlFor="wp-inquiryType" className="text-size-sm text-color-secondary">Inquiry type *</label>
                          <select id="wp-inquiryType" className="w-input" name="inquiryType"
                            value={form.inquiryType} onChange={handleField} required aria-required="true"
                            style={{ display: 'block', width: '100%', marginTop: '0.4rem', appearance: 'auto' }}>
                            <option value="">Select inquiry type</option>
                            {INQUIRY_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                          </select>
                        </div>
                        <div>
                          <label htmlFor="wp-message" className="text-size-sm text-color-secondary">Message *</label>
                          <textarea id="wp-message" className="w-input" name="message" maxLength={3000}
                            value={form.message} onChange={handleField} required aria-required="true" rows={5}
                            style={{ display: 'block', width: '100%', marginTop: '0.4rem', resize: 'vertical' }} />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.6rem' }}>
                          <input id="wp-consent" type="checkbox" name="consent"
                            checked={form.consent} onChange={handleField} required aria-required="true"
                            style={{ marginTop: '2px', flexShrink: 0 }} />
                          <label htmlFor="wp-consent" className="text-size-sm text-color-secondary">
                            I agree that Woss Publishing may use this information to respond to my inquiry. *
                          </label>
                        </div>
                      </div>

                      {formError && (
                        <div className="form_message-error is-visible" role="alert" style={{ marginTop: '1rem' }}>
                          {formError}
                        </div>
                      )}

                      <div style={{ marginTop: '1.5rem' }}>
                        <button
                          type="submit"
                          className="button w-inline-block"
                          disabled={formStatus === 'sending'}
                          style={{ background: 'none', border: 'none', cursor: formStatus === 'sending' ? 'wait' : 'pointer', opacity: formStatus === 'sending' ? 0.7 : 1 }}
                          aria-label="Send inquiry"
                        >
                          <span className="text-size-sm">{formStatus === 'sending' ? 'Sending…' : 'Send Inquiry'}</span>
                          <div className="button_icon"><ArrowSvg /></div>
                        </button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
}
